import { render } from "./CalendarComponent.vue?vue&type=template&id=a9b5bf06"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=a9b5bf06&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__